import React from 'react';
import { MagnifyingGlass, Car, Jeep, Van, Bus, Train } from '@phosphor-icons/react';

const VEHICLE_TYPES = [
  { key: null, label: 'All', Icon: null },
  { key: 'sedan', label: 'Cars', Icon: Car },
  { key: 'suv', label: 'SUV', Icon: Jeep },
  { key: 'van', label: 'Vans', Icon: Van },
  { key: 'minibus', label: 'Minibus', Icon: Bus },
  { key: 'coach', label: 'Coach', Icon: Bus },
  { key: 'rail', label: 'Rail', Icon: Train },
];

const TransportFilters = ({
  vehicleType,
  onVehicleTypeChange,
  searchText = '',
  onSearchChange,
  onApply,
  onClear,
  loading = false,
  passengerCount,
  onPassengerCountChange,
}) => (
  <div className="ls-filter-bar ls-elevated p-2 sm:p-3 mb-3 sm:mb-4 rounded-lg">
    <div className="flex flex-col sm:flex-row sm:flex-wrap items-stretch sm:items-center gap-2 mb-2">
      <div className="relative flex-1 min-w-0 sm:min-w-[180px]">
        <MagnifyingGlass size={14} weight="bold" className="absolute left-2.5 top-1/2 -translate-y-1/2" style={{ color: 'var(--ls-muted)' }} />
        <input
          type="text" className="ls-input w-full !pl-8 !py-2 text-sm"
          placeholder="Search depots, stations..."
          value={searchText} onChange={(e) => onSearchChange(e.target.value)}
          data-testid="ls-transport-filter-search"
        />
      </div>

      <div className="flex items-center gap-2">
        <span className="text-[10px] font-semibold flex-shrink-0" style={{ color: 'var(--ls-muted)' }}>Passengers</span>
        <input
          type="number" className="ls-input !w-16 !py-1 !px-2 text-xs text-center"
          placeholder="1" value={passengerCount ?? ''}
          onChange={(e) => onPassengerCountChange(e.target.value ? Number(e.target.value) : null)}
          min={1} max={100}
        />
      </div>

      <div className="flex items-center gap-2">
        <button className="ls-btn-primary !py-2 text-xs flex-1 sm:flex-none justify-center" onClick={onApply} disabled={loading}>
          {loading ? 'Loading...' : 'Search'}
        </button>
        <button className="ls-btn-ghost !py-2 text-xs" onClick={onClear}>Clear</button>
      </div>
    </div>

    <div className="flex items-center gap-1 overflow-x-auto scrollbar-hide pb-1">
      {VEHICLE_TYPES.map(({ key, label, Icon }) => (
        <button
          key={label}
          className="text-[11px] px-2.5 py-1 rounded-full font-semibold transition-colors flex items-center gap-1 flex-shrink-0"
          style={{
            background: vehicleType === key ? 'var(--ls-primary)' : 'var(--ls-elevated)',
            color: vehicleType === key ? 'var(--ls-primary-fg)' : 'var(--ls-muted)',
            border: '1px solid ' + (vehicleType === key ? 'var(--ls-primary)' : 'var(--ls-border)'),
          }}
          onClick={() => onVehicleTypeChange(vehicleType === key ? null : key)}
        >
          {Icon && <Icon size={11} weight="bold" />}
          {label}
        </button>
      ))}
    </div>
  </div>
);

export default TransportFilters;
